import { combineReducers } from 'redux'
import sessionReducer from './session'
import userReducer from './user'
import introQuestions from './introQuestions'
import currentQuestionIndex from './currentIntroQuestion'
import prevQuestionIndex from './prevIntroQuestion'
import plantList from './plantList'
import deviceList from './deviceList'
import devices from './devices'
import plants from './plants'
import search from './search'
import settings from './settings'
import favoritePlants from './favoritePlants'
import classifier from './classifier'
import tensorflowModel from './tensorflowModels'

const rootReducer = combineReducers({
    classifier,
    currentQuestionIndex,
    deviceList,
    devices,
    favoritePlants,
    introQuestions,
    plantList,
    plants,
    prevQuestionIndex,
    search,
    sessionState: sessionReducer,
    settings,
    tensorflowModel,
    userState: userReducer,
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js